import React from 'react';
import type { EmojiClickData } from 'emoji-picker-react';
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react';
import type { PreviewConfig } from 'emoji-picker-react/src/config/config';
import { isDarkTheme } from '../../util';
import { Breakpoints, useBreakpoint } from '../../lib';
import type { EmojiData } from 'emoji-picker-react/src/types/exposedTypes';

export type EmojiProps = {
  addMessage: (emojiObject: EmojiClickData) => void;
  /**
   * Overrides the default height. Needed when the picker is rendered in normal
   * document flow instead of as a floating layer, because the default mobile
   * height of `50%` has no definite containing block to resolve against.
   */
  height?: string | number;
  emojiData: EmojiData;
};
export const previewConfig: PreviewConfig = {
  defaultEmoji: '',
  defaultCaption: '',
  showPreview: false
};
export function EmojiPickerComp({
  addMessage,
  height,
  emojiData
}: Readonly<EmojiProps>): React.JSX.Element {
  const isMobile = useBreakpoint(Breakpoints.MOBILE);
  return (
    <EmojiPicker
      theme={isDarkTheme() ? Theme.DARK : Theme.LIGHT}
      searchDisabled={true}
      previewConfig={previewConfig}
      width={isMobile ? '100%' : 350}
      height={height ?? (isMobile ? '50%' : 400)}
      emojiData={emojiData}
      emojiStyle={EmojiStyle.NATIVE}
      onEmojiClick={emojiObject => {
        addMessage(emojiObject);
      }}
      skinTonesDisabled={true}
    />
  );
}
